// Toto je VUE app entry point
import Vue from "vue";
import App from "./App";
import router from "./router";

// Create a global event bus
export const eventBus = new Vue();

import { BootstrapVue, IconsPlugin, FormPlugin } from "bootstrap-vue";

Vue.config.productionTip = false;

// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

Vue.use(FormPlugin);

// This imports all the layout components such as <b-container>, <b-row>, <b-col>:
import { LayoutPlugin } from "bootstrap-vue";
Vue.use(LayoutPlugin);

// This imports <b-modal> as well as the v-b-modal directive as a plugin:
import { ModalPlugin } from "bootstrap-vue";
Vue.use(ModalPlugin);

// This imports <b-card> along with all the <b-card-*> sub-components as a plugin:
import { CardPlugin } from "bootstrap-vue";
Vue.use(CardPlugin);

// This imports directive v-b-scrollspy as a plugin:
import { VBScrollspyPlugin } from "bootstrap-vue";
Vue.use(VBScrollspyPlugin);

// This imports the dropdown and table plugins
import { DropdownPlugin, TablePlugin } from "bootstrap-vue";
Vue.use(DropdownPlugin);
Vue.use(TablePlugin);

// List group plugin
import { ListGroupPlugin } from "bootstrap-vue";
Vue.use(ListGroupPlugin);

// Title mixin
import titleMixin from "./mixins/titleMixin";
Vue.mixin(titleMixin);

// Načíst customer UUID z cesty
var customerUuid = window.location.pathname.split("/")[1];
Vue.prototype.$customerUuid = customerUuid;
console.debug("Customer Uuid: " + customerUuid);

// Vytvořit novou instanci backend wrapper a zpřístupnit všem instancím Vue
import { BackendPlugin } from "./backend";

import i18n from "./i18n";
Vue.use(BackendPlugin, customerUuid, router);

// Vuex
import Vuex from "vuex";
import { store } from "./store";
Vue.use(Vuex);

// Utils
import { UtilsPlugin } from "./utils";
Vue.use(UtilsPlugin, { i18n });

// Pro možnost automatického odhlášení při nečinnosti
import Vidle from "v-idle";
Vue.use(Vidle);

// System gov
import { ComponentLibrary } from '@gov-design-system-ce/vue/dist/plugin';
Vue.use(ComponentLibrary); // <-- registrace knihovny

Vue.config.errorHandler = (err, vm, info) => {
  try{
    Vue.prototype.$backend.logPowebError(null, err.message, null, err.stack);
  } catch (e) {
    console.error("Chyba pri logovani chyby:", e);
  }
};

new Vue({
  store: store,
  router,
  i18n,
  render: h => h(App),
}).$mount("#app");

// pro debug, v produkci odstranit
Vue.config.productionTip = false;
Vue.mixin({
  created() {
    console.debug("[created] " + this.$options.name);
  },
});
